import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Ion } from "@/components/Ion";
import { useTheme } from "@/lib/theme";

// Shared pieces matching the original screens' header / card / button styles.
export const useBack = (fallback = "/dashboard") => {
  const navigate = useNavigate();
  return () => (window.history.length > 1 ? navigate(-1) : navigate(fallback));
};

export const Screen = ({ children, testId, className = "" }) => {
  const theme = useTheme();
  return <div className={`min-h-screen font-body ${className}`} style={{ background: theme.bg, color: theme.text }} data-testid={testId}>{children}</div>;
};

export const OrigHeader = ({ eyebrow, title, right, titleSize = 22, compact = false, fallback }) => {
  const theme = useTheme();
  const back = useBack(fallback);
  return (
    <div className={`flex items-center gap-4 ${compact ? "p-4" : "p-6 pb-4"}`}>
      <button data-testid="back-btn" onClick={back} aria-label="Back" className="flex h-10 w-10 shrink-0 items-center justify-center rounded-[10px] border" style={{ background: theme.card, borderColor: theme.border }}>
        <Ion name="chevron-back" size={22} color={theme.text} />
      </button>
      <div className="min-w-0 flex-1">
        {eyebrow && <p className="text-[11px] font-bold tracking-[3px]" style={{ color: theme.accent }}>{eyebrow}</p>}
        <h1 className="mt-0.5 truncate font-extrabold" style={{ fontSize: titleSize }} data-testid="page-title">{title}</h1>
      </div>
      {right}
    </div>
  );
};

export const Spinner = () => {
  const theme = useTheme();
  return <div className="flex justify-center pt-10"><Loader2 className="animate-spin" style={{ color: theme.accent }} /></div>;
};

export const OCard = ({ children, className = "", style, ...rest }) => {
  const theme = useTheme();
  return <div {...rest} className={`rounded-[14px] border p-4 ${className}`} style={{ background: theme.card, borderColor: theme.border, ...style }}>{children}</div>;
};

export const PrimaryBtn = ({ children, className = "", ...props }) => {
  const theme = useTheme();
  return <button {...props} className={`flex w-full items-center justify-center gap-2 rounded-lg py-3.5 text-[13px] font-extrabold tracking-[1.5px] text-black disabled:opacity-50 ${className}`} style={{ background: theme.accent }}>{children}</button>;
};

export const inputCls = "w-full rounded-lg border border-[#333] bg-[#1A1A1A] p-4 text-sm text-white placeholder:text-[#A0A0A0] focus:outline-none focus:border-[var(--accent)]";
